import { Button, Typography } from '@mui/material';
import PricingCardItem from './PricingCardItem';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { SET_MODAL_STATUS, SET_MODAL_TYPE, SET_TOAST_OBJECT } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import { GET_USER_DETAILS_WITH_COMPANY } from 'schemas/query';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import { Container } from '@mui/system';
// import useIsInViewport from 'Components/VisibiilityDetectorViewPortComponent';
import AddPricingWrapper from './AddPricingWrapper';
import UpdatePricingWrapper from './UpdatePricingWrapper';
import UpdatePricingCardItem from './UpdatePricingCardItem';
// import { COMPONENT_TYPE } from './pricing-constants';
import { ArrowBack } from '@mui/icons-material';
import DashboardModalBox from '../ModalBox';
const Pricings = (props) => {
    const { selectedPlan, componentType } = props;
    const locationParams = useLocation();
    const [planList, setPlansList] = useState([]);
    const [selectedPlanId, setSelectedPlanId] = useState('');
    const [selectedPlanType, setSelectPlanType] = useState('');
    const dispatch = useDispatch();
    const token = localStorage.getItem('diologAuthToken') || '';
    const navigate = useNavigate();
    const [isRefetch, setRefetch] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isReactivate, setIsReactivate] = useState(false);
    const [loading, setLoading] = useState(false);
    const { isNewToken } = useSelector((params) => params.customization);
    const [tierList, setTierList] = useState([]);
    const userParsedData = localStorage?.getItem('diologUserData') ? JSON.parse(localStorage?.getItem('diologUserData')) : {};

    const getTierQuantity = (quantity) => {
        if (Number(quantity <= 5000)) return '5000';
        else if (Number(quantity <= 20000)) return '20000';
        else if (Number(quantity <= 50000)) return '50000';
        else if (Number(quantity <= 100000)) return '100000';
        else return 'infinite';
    };
    const [selectedTier, setSelectedTier] = useState(getTierQuantity(userParsedData?.quantity || 0));
    const [getCompanyDetail] = useLazyQuery(GET_USER_DETAILS_WITH_COMPANY, {
        onCompleted: (data) => {
            const { loggedInUserDetailWithCompanyData } = data;
            localStorage.setItem('diologUserData', JSON.stringify(loggedInUserDetailWithCompanyData));
            if (componentType === 'Add')
                navigate({
                    pathname: '/dashboard/invite-team',
                    search: createSearchParams({
                        type: 'stripe_success'
                    }).toString()
                });
            else
                navigate({
                    pathname: '/dashboard',
                    search: createSearchParams({
                        type: 'stripe_success'
                    }).toString()
                });
        }
    });

    // console.log(componentType);

    /**Refetch company after plan is updated when choosing plan */
    useEffect(() => {
        if (isRefetch) getCompanyDetail();
    }, [isRefetch]);

    // const buttonContinueRef = useRef(null);
    // const isViewPortNeeded = COMPONENT_TYPE.ADD === componentType ? true : false;

    // const isButtonContinueRef = useIsInViewport(buttonContinueRef, isViewPortNeeded);
    const getPriceFromTier = (tier) => {
        const getItem = tierList?.find((item) => Number(item.up_to) === Number(tier));
        return getItem;
    };
    const onClickSelectedPlan = (id) => {
        const priceFromTier = getPriceFromTier(id);
        setSelectedTier(priceFromTier?.up_to || 'infinite');
    };

    useEffect(() => {
        setSelectPlanType(selectedPlan);
    }, [selectedPlan]);

    const checkSelectionPlan = (selectedPlanTypeCurrent, selectedPlanIdCurrent, userBaseRange) =>
        selectedPlanTypeCurrent && selectedPlanIdCurrent && token && userBaseRange ? true : false;

    const setDispatchErrorMessage = (message, variant) => {
        dispatch({
            type: SET_TOAST_OBJECT,
            toastObject: {
                variant: variant,
                message: message,
                status: true
            }
        });
    };

    const callApi = async (body) => {
        try {
            setLoading(true);
            const response = await axios({
                method: 'POST',
                url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/subscribe/v2',
                data: body,
                headers: { Authorization: `${token}` }
            });
            return response;
        } catch (e) {
            // setDispatchErrorMessage(e?.response?.data?.message || e.message || 'Sorry something error occcured.', 'error');
            throw e;
        } finally {
            setLoading(false);
        }
    };

    const actionAfterPostingPlanSelection = (type, response) => {
        if (type === PLAN_TYPE.Premium) window.location.href = response?.data?.url || '/dashboard?type=stripe_success';
        else setRefetch(true);
    };

    const onHandleClickAddPlan = async (id, planType) => {
        if (checkSelectionPlan(id, planType, selectedTier)) {
            try {
                let body = {
                    type: planType,
                    priceId: id,
                    range: PLAN_TYPE.Freemium === planType ? '5000' : selectedTier
                };
                const response = await callApi(body);
                actionAfterPostingPlanSelection(planType, response);
            } catch (e) {
                setDispatchErrorMessage(e?.response?.data?.message || e.message || 'Sorry something error occcured.', 'error');
            }
        } else setDispatchErrorMessage('Plan id and plan type and token is required', 'error');
    };

    const onUpdatePlan = async (type, planId) => {
        if (checkSelectionPlan(type, planId, selectedTier)) {
            try {
                let body = {
                    type: type,
                    priceId: planId,
                    flag: true,
                    range: PLAN_TYPE.Freemium === type ? '5000' : Number(selectedTier) < 5000 ? '5000' : selectedTier
                };
                if (selectedPlan === PLAN_TYPE.Freemium && type === PLAN_TYPE.Freemium)
                    setDispatchErrorMessage(`You are already subscribed to ${PLAN_TYPE.Freemium} plan.`, 'warning');

                const response = await callApi(body);
                actionAfterPostingPlanSelection(type, response);
            } catch (e) {
                //setDispatchErrorMessage('')
            }
        } else setDispatchErrorMessage('Plan id and plan type and token is required', 'error');
    };
    const onReactivatePlan = async () => {
        const planItem = planList.find((plan) => plan.name === userParsedData.plan);
        if (!planItem) {
            setDispatchErrorMessage('No plan id was provided', 'error');
            return;
        }
        try {
            let body = {
                type: userParsedData?.plan,
                priceId: planItem.default_price,
                flag: true,
                range: userParsedData?.quantity,
                isReactivate: isReactivate
            };
            const response = await callApi(body);
            actionAfterPostingPlanSelection(body.type, response);
        } catch (e) {
            setDispatchErrorMessage(e?.response?.data?.message || e.message || 'Sorry something error occcured.', 'error');
        }
    };

    useEffect(() => {
        axios({
            method: 'GET',
            url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/products/v2'
        }).then(function (response) {
            setPlansList(response.data.data);
            const findPremiumId = response?.data?.data?.find((item) => item.name === PLAN_TYPE.Premium);
            axios({
                method: 'GET',
                url: process.env.REACT_APP_SUBSCRIPTION_BASE_URL + '/stripe/product/' + findPremiumId.id + '/volume-prices'
            }).then((response) => {
                console.log('response', response.data);
                setTierList(response.data);
            });
        });
    }, []);

    useEffect(() => {
        if (location.search === '?type=stripe_failure') {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: `Subscription Failed`
                }
            });
            setSearchParams('');
            setRefetch(false);
        }
    }, [isNewToken, location]);

    useEffect(() => {
        if (locationParams.search) {
            let stripeType = locationParams.search.split('?isReactivate=').join('');
            console.log(stripeType);
            if (stripeType === 'Yes') {
                setIsReactivate(true);
            }
        }
    }, [locationParams]);

    return (
        <>
            <div className={`pricingMainWrapper ${componentType === 'Update' ? 'pricing-main-edit' : ''}`}>
                <Container maxWidth="xl" sx={{ background: '#fff' }}>
                    {/* <AddPricingWrapper componentType={componentType}>
                        <Button
                            disabled={loading || !selectedPlanType || !selectedPlanId}
                            onClick={onHandleClickAddPlan}
                            ref={buttonContinueRef}
                            className="pricing-button-heading medium float-right"
                        >
                            {selectedPlanType === PLAN_TYPE.Premium ? 'Continue to payment' : 'Continue'}
                        </Button>
                    </AddPricingWrapper> */}
                    <UpdatePricingWrapper componentType={componentType}>
                        <Button className="pricing-button-back medium" onClick={() => navigate(-1)}>
                            <Typography component="span" variant="h4" style={{ display: 'flex', alignItems: 'center' }}>
                                <ArrowBack color="#00214d" />
                            </Typography>
                            <Typography component="span" variant="h4">
                                Back
                            </Typography>
                        </Button>
                    </UpdatePricingWrapper>
                </Container>

                <Container sx={{ background: '#fff' }} maxWidth="xl">
                    <div className="pricingWrapper">
                        <div className="pricingInnerWrapper">
                            <div className="pricing-header">
                                {componentType === 'Update' && <h2 className="subtile-heading text-center text-dark-blue">Pricing</h2>}
                                <h1 className="text-dark-blue text-center title-heading">Plans for all shareholder bases</h1>
                                <p className="sub-content-heading text-dark-blue text-center">
                                    Better investor relationships are right around the corner.
                                </p>
                            </div>
                            <AddPricingWrapper componentType={componentType}>
                                {/* <div className="buttonDiv"> */}
                                {/* {!isButtonContinueRef && (
                                            <Button
                                                className="pricing-button large"
                                                onClick={onHandleClickAddPlan}
                                                disabled={loading || !selectedPlanType || !selectedPlanId}
                                            >
                                                {selectedPlanType === PLAN_TYPE.Premium ? 'Continue to payment' : 'Continue'}
                                            </Button>
                                        )} */}
                                {/* </div> */}

                                <PricingCardItem
                                    planList={planList}
                                    loading={loading}
                                    selectedPlan={selectedPlanType}
                                    setSelectedPlans={onClickSelectedPlan}
                                    selectedTier={selectedTier}
                                    // isButtonContinueRef={isButtonContinueRef}
                                    onHandleClickPlan={onHandleClickAddPlan}
                                    selectedPlanId={selectedPlanId}
                                />
                            </AddPricingWrapper>
                            <UpdatePricingWrapper componentType={componentType}>
                                <UpdatePricingCardItem
                                    loading={loading}
                                    planList={planList}
                                    setSelectedPlans={onClickSelectedPlan}
                                    selectedPlan={selectedPlanType}
                                    selectedTier={selectedTier}
                                    // isButtonContinueRef={isButtonContinueRef}
                                    isReactivate={isReactivate}
                                    onHandleClickUpdatePlan={onUpdatePlan}
                                    selectedPlanId={selectedPlanId}
                                    onReactivatePlan={onReactivatePlan}
                                />
                            </UpdatePricingWrapper>
                        </div>
                    </div>
                </Container>
            </div>
            <DashboardModalBox />
        </>
    );
};
export default Pricings;
